import {DateTime} from 'luxon';
import {parseEventDateTime} from '~/common/utils/time';
import {
  selectCohost as selectEviteEventCohost,
  selectHostIds as selectEviteEventHostIds,
  selectPhoneNumber as selectEviteEventPhoneNumber,
  selectIsPremium as selectIsEviteEventPremium,
} from './eviteEvent';

export const selectEventDetails = ({eventDetails}) => eventDetails;
export const selectGuestsOfHonor = (state) => selectEventDetails(state)?.guestsOfHonor ?? [];
export const selectHostName = (state) =>
  selectEventDetails(state)?.host_name ?? selectEventDetails(state)?.hostName ?? '';
export const selectEventLocationName = (state) => selectEventDetails(state)?.locationName;
export const selectEventAddress = (state) => selectEventDetails(state)?.streetAddress;
export const selectEventMeetingUrl = (state) => selectEventDetails(state)?.meetingUrl;
export const selectEventPhoneNumber = (state) => selectEventDetails(state)?.phoneNumber;
export const selectIsPremium = (state) =>
  selectEventDetails(state)?.isPremium || selectIsEviteEventPremium(state).isPremium;
export const selectRegistriesData = (state) => selectEventDetails(state).registriesData ?? false;
export const selectMaxAdditionalGuests = (state) => selectEventDetails(state).maxGuests;
export const selectAllowKids = (state) => !!selectEventDetails(state).allowKids;
export const selectAllowGuestsToBringMoreGuests = (state) =>
  selectEventDetails(state)?.allowGuests ?? false;
export const selectAllowGuestsToInviteMore = (state) =>
  selectEventDetails(state)?.allowInviteMore ?? false;
export const selectEventType = (state) => selectEventDetails(state)?.eventType;
export const selectEventId = (state) => selectEventDetails(state)?.eventId;
export const selectEventTitle = (state) => selectEventDetails(state)?.title;
export const selectEventStatus = (state) => selectEventDetails(state)?.status;
export const selectWidgets = (state) => selectEventDetails(state)?.widgets;
export const selectEventStart = (state) => selectEventDetails(state)?.start;
export const selectEventEnd = (state) => selectEventDetails(state)?.end;
export const selectEventTimezone = (state) => selectEventDetails(state)?.known_timezone_name;
export const selectEventIsFuneral = (state) =>
  selectEventDetails(state)?.eventType === 'funeral_memorial_service';
export const selectEventIsFutureNonFuneral = (state) => {
  const eventStart = selectEventStart(state);
  const timezone = selectEventTimezone(state);
  // TODO: this is the old way, we should be using event classification
  const eventIsFuneral = selectEventIsFuneral(state);
  const eventStartDt = parseEventDateTime(eventStart, timezone);
  const midnightTonight = DateTime.now().plus({days: 1}).startOf('day');
  const eventIsAfterToday = eventStartDt.isValid && eventStartDt > midnightTonight;
  return !eventIsFuneral && eventIsAfterToday;
};
export const selectTitle = (state) => selectEventDetails(state)?.title;
export const selectLocationName = (state) => selectEventDetails(state)?.locationName;
export const selectStreetAddress = (state) => selectEventDetails(state)?.streetAddress;
export const selectMeetingUrl = (state) => selectEventDetails(state)?.meetingUrl;
export const selectMessageFromHost = (state) => selectEventDetails(state)?.messageFromHost;
export const selectHasMessageFromHost = (state) => Boolean(selectMessageFromHost(state));
export const selectPhoneNumber = (state) =>
  selectEventDetails(state).phoneNumber ?? selectEviteEventPhoneNumber(state);
export const selectCohost = (state) => {
  const cohost = selectEventDetails(state).cohost;
  return {
    name: cohost?.name ?? selectEviteEventCohost(state).name,
    email: cohost?.email ?? selectEviteEventCohost(state).email,
  };
};
export const selectHostIds = (state) =>
  selectEventDetails(state).host_ids || selectEviteEventHostIds(state);
export const selectOrigin = (state) => selectEventDetails(state).origin;
export const selectIsPro = (state) => selectEventDetails(state)?.isPro ?? false;
export const selectIsUpgrade = (state) => selectEventDetails(state)?.isUpgrade ?? false;
export const selectCardHasShadow = (state) =>
  selectEventDetails(state)?.design?.card_shadow ?? false;
